import moment from "moment";
import axios from "axios";
import { takeLatest, put, all, call, select } from "redux-saga/effects";
import { BASE_URL_API } from "../../configs/env";
import { openSnackbar } from "../snackbar/snackbar.action";
import queryString from "query-string";
import {
	clearMonthlyActivityPlanError,
	fetchAllMonthlyActivityPlanStart,
	fetchAllMonthlyActivityPlanSuccess,
	fetchAllMonthlyActivityPlanFailure,
	createMonthlyActivityPlanSuccess,
	createMonthlyActivityPlanFailure,
	updateMonthlyActivityPlanSuccess,
	updateMonthlyActivityPlanFailure,
} from "./monthly-activity-plan.action";
import MonthlyActivityPlan from "./monthly-activity-plan.types";
import { selectCurrentUser } from "../user/user.selector";
import { selectCurrentUserCompany } from "../company/company.selector";

export function* fetchAllMonthlyActivityPlan({ payload }) {
	const filters = payload;
	const query = queryString.stringify({
		isDeleted: 0,
		pageSize: 0,
		sidx: "block.blockName",
		sord: "asc",
		...filters,
	});
	try {
		const response = yield axios({
			method: "GET",
			url: `${BASE_URL_API}/monthly-activity-plans?${query}`,
		});

		if (!response.data.success) {
			throw new Error(response.data.message);
		}

		const vehicles = response.data.records;

		yield put(fetchAllMonthlyActivityPlanSuccess(vehicles));
	} catch (error) {
		const errorMessage =
			(error.response && error.response.data.message) || error.message;
		const snackbarData = {
			message: errorMessage,
			color: "error",
			place: "bl",
			dispatchActions: [clearMonthlyActivityPlanError],
		};
		yield put(openSnackbar(snackbarData));
		yield put(fetchAllMonthlyActivityPlanFailure(errorMessage));
	}
}

export function* onFetchAllMonthlyActivityPlan() {
	yield takeLatest(MonthlyActivityPlan.FETCH_ALL_MONTHLY_ACTIVITY_PLAN_START, fetchAllMonthlyActivityPlan);
}

export function* createMonthlyActivityPlan({ payload }) {
	const currentUser = yield select(selectCurrentUser);
	const company = yield select(selectCurrentUserCompany);
	const { info, filter } = payload;
	try {
		const uuid = yield axios({
			method: "GET",
			url: "https://www.uuidgenerator.net/api/version1",
		});

		const response = yield axios({
			method: "POST",
			url: `${BASE_URL_API}/monthly-activity-plans`,
			data: {
				activityTypeId: info.activityTypeId,
				afdelingId: info.afdelingId,
				blockId: info.blockId,
				companyId: company.id,
				companyName: company.name,
				createdBy: currentUser.name,
				createdTime: moment().format("YYYY-MM-DD[T]HH:mm:ssZZ"),
				estateId: info.estateId,
				ha: info.ha,
				hk: info.hk,
				hkPerHa: info.hkPerHa,
				id: uuid.data,
				isDeleted: 0,
				planMonth: info.planMonth,
				planYear: info.planYear,
				updatedBy: currentUser.name,
				updatedTime: moment().format("YYYY-MM-DD[T]HH:mm:ssZZ"),
				userId: currentUser.id,
				userName: currentUser.name,
			},
		});

		if (!response.data.success) {
			throw new Error(response.data.message);
		}

		yield put(createMonthlyActivityPlanSuccess());
		yield put(fetchAllMonthlyActivityPlanStart(filter));
	} catch (error) {
		const errorMessage =
			(error.response && error.response.data.message) || error.message;
		const snackbarData = {
			message: errorMessage,
			color: "error",
			place: "bl",
			dispatchActions: [clearMonthlyActivityPlanError],
		};
		yield put(openSnackbar(snackbarData));
		yield put(createMonthlyActivityPlanFailure(errorMessage));
	}
}

export function* onCreateMonthlyActivityPlan() {
	yield takeLatest(MonthlyActivityPlan.CREATE_MONTHLY_ACTIVITY_PLAN_START, createMonthlyActivityPlan);
}

export function* updateMonthlyActivityPlan({ payload }) {
	const { newMonth, current, filter } = payload;
	const currentUser = yield select(selectCurrentUser);
	const company = yield select(selectCurrentUserCompany);
	try {
		const response = yield axios({
			method: "PUT",
			url: `${BASE_URL_API}/monthly-activity-plans/${current.id}`,
			data: {
				activityTypeId: current.activityTypeId,
				activityTypeName: current.activityTypeName,
				afdelingId: current.afdelingId,
				afdelingName: current.afdelingName,
				blockId: current.blockId,
				blockName: current.blockName,
				companyId: company.id,
				companyName: company.name,
				estateId: current.estateId,
				estateName: current.estateName,
				ha: current.ha,
				hk: current.hk,
				hkPerHa: current.hkPerHa,
				id: current.id,
				planMonth: newMonth,
				planYear: current.planYear,
				updatedBy: currentUser.name,
				updatedTime: moment().format("YYYY-MM-DD[T]HH:mm:ssZZ"),
				userId: currentUser.id,
				userName: currentUser.name,
				version: current.version + 1,
			},
		});

		if (!response.data.success) {
			throw new Error(response.data.message);
		}

		yield put(updateMonthlyActivityPlanSuccess());
		yield put(fetchAllMonthlyActivityPlanStart(filter));
	} catch (error) {
		const errorMessage =
			(error.response && error.response.data.message) || error.message;
		const snackbarData = {
			message: errorMessage,
			color: "error",
			place: "bl",
			dispatchActions: [clearMonthlyActivityPlanError],
		};
		yield put(openSnackbar(snackbarData));
		yield put(updateMonthlyActivityPlanFailure(errorMessage));
	}
}

export function* onUpdateMonthlyActivityPlan() {
	yield takeLatest(MonthlyActivityPlan.UPDATE_MONTHLY_ACTIVITY_PLAN_START, updateMonthlyActivityPlan);
}

export function* monthlyActivityPlanSagas() {
	yield all([
		call(onFetchAllMonthlyActivityPlan),
		call(onCreateMonthlyActivityPlan),
		call(onUpdateMonthlyActivityPlan),
	]);
}
